import { createApp } from "vue";
import App from "./App.vue";
import "./assets/css/public.css";
import "./assets/js/ref.js";
import VueI18n from './language'
createApp(App)
.use(VueI18n)
.mount("#app");
